module.exports = __webpack_public_path__ + "img/logo-pse.47fb616a.png";